import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lansweeper = defineConnector({
  identifier: "lansweeper",
  name: "Lansweeper",
  tagLine: "IT asset management and discovery",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.lansweeper\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Lansweeper](https://www.lansweeper.com/), go to your site settings, select **Developer tools → Add new API client**, and create a personal access token. Copy the token before closing the window.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Lansweeper API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.lansweeper.com/api/v2/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ me { username } }" }),
    }),
  },
});
